import { ConfigStore } from "../../store/modules/config";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { CardPinModel } from "../../models/cardOperations/CardPinModel";
import IAlertService from "../../services/alert/IAlertService";
import { ContractsStore } from "../../store/modules/contracts";
import { Dictionary } from "../../data/types";

/**
 *  Класс для компоненты модального окна смены PIN карты.
 */
export class CardPinModalVue extends OperationVue {

  /** Входные параметры */  
  @Prop() params!: any;

  operationInitData: Dictionary<string> = {};

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */  
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Сервис проведения операций каталога
 * @returns {IOperationService}
 */
  get operationService(): IOperationService {
    return container.get<IOperationService>(DiTokens.CardPinService);
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */  
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }


  /**
 * Код операции
 * @returns {string} - код для отправки апи.
 */
  get respondentCode(): string {
    return this.configStore.apiData.OperationCodeOfCardPinCode;
  }

  /**Инициализация формы */
  async init(): Promise<void> {
    await this.initOperation();
  }

  // /**Метод для выполнения после успешного проведения */
  // async afterExecute(): Promise<void> {
  //   super.afterExecute();
  //   this.alertService.success(
  //     i18n
  //       .t(`main.cards.messages.PINchanged`, {
  //         pan: this.params.card.Data.Number
  //       })
  //       .toString()
  //   );
  // }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.CardPinService);
    this.OperationModel = (await this.operationService.init({
      code: this.respondentCode,
      card: this.params.card
    })) as CardPinModel;
    this.operationInitData['card'] = this.params.card?.Data.ReferenceId;
    this.loading = false;
  }
}
